import React, { useState, useEffect, useMemo } from 'react'
import moment from 'moment'
import { useSelector, useDispatch } from 'react-redux'
import { fetchFeed, setAttr } from '../redux/feedInfiniteSlice'
import { deleteDraft } from '../redux/apis'
import { useQuery } from 'react-query'
import { getMyUserEvents } from '../redux/apis'

import Detail from '../components/DesignerCommon/Detail'
import Feed from '../components/DesignerFeed/Feed'
import DesignFeedContainer from '../components/DesignerDesigns/DesignFeedContainer'
import DesignFeedCard from '../components/DesignerDesigns/cards/DesignFeedCard'
import DeleteConfirmation from '../components/DesignerModals/DeleteConfirmation'

import { FEED_RESET } from '../redux/constants'
import { logEvent } from '../utils/firebase'
import {
  PrimaryAltButton,
  PrimaryButton
} from '../components/common/FormControls'
import styled from 'styled-components'
import { useRouter } from 'next/router'
import UserEventLevelLimitationModal from '../components/UserEventLevelLimitationModal'
import { ReactComponent as BackIcon } from '../assets/backcircle.svg'
import { useIsMobile } from '../hooks/useIsMobile'
import useMediaQuery from '../hooks/useMediaQuery'
import noitems from '../assets/noitems.png'

import {
  statusesByTab,
  statusTitles
} from '../routes/Profile/components/MyEvent'
import MyEventCard from '../routes/Profile/components/MyEventCard'

export const CardWrapper = styled.div`
  height: 300px;
  width: 300px;

  @media only screen and (max-width: 870px) {
    width: calc(50% - 6px);
    aspect-ratio: 1/1;
    height: auto;

    & > * {
      width: 100%;
      height: 100%;
    }
  }
`

export const NoEvent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding-top: 50px;

  & img {
    max-height: 307px;
    max-width: 475px;
    width: 95%;
    object-fit: contain;

    @media only screen and (max-width: 500px) {
      height: min(167px, 90vw);
      width: min(258px, 90vw);
    }
  }

  & span {
    font-family: Helvetica Neue;
    font-size: 18px;
    font-weight: 500;
    line-height: 22px;
    color: #979797;
    margin: 70px 0 30px;

    @media only screen and (max-width: 500px) {
      font-size: 13px;
      font-weight: 500;
      line-height: 16px;
      margin: 30px 0 20px;
    }
  }

  & button {
    height: 44px;
    width: 280px;
    border-radius: 22px;
    background: #ff5e6d;
    color: #fff;
    font-family: Helvetica Neue;
    font-size: 14px;
    font-weight: 700;
    text-align: center;
    border: 0;
    cursor: pointer;
    max-width: 244px;
  }
`

export const Row = styled.div`
  margin-bottom: 36px;
  width: 100%;

  @media only screen and (max-width: 500px) {
    margin-bottom: 20px;
  }
`

const RowTitle = styled.h3`
  font-size: 24px;
  font-weight: 700;
  line-height: 29px;
  margin: 0 0 15px;

  @media only screen and (max-width: 768px) {
    border-bottom: 1px solid #e8e8e8;

    font-size: 16px;
    line-height: 16px;
    padding-bottom: 8px;
  }
`

export const Grid = styled.div`
  display: flex;
  flex-wrap: wrap;
  grid-gap: 22px;
  width: 100%;
  box-sizing: border-box;

  @media only screen and (max-width: 1450px) {
    gap: 14px;
  }
  @media only screen and (max-width: 1250px) {
    gap: 11px;
    margin: auto;
  }
`

const Back = styled(BackIcon)`
  cursor: pointer;
`

const BackContainer = styled.div`
  position: absolute;
  top: 21px;

  @media only screen and (min-width: 768px) {
    left: 16px;
  }
`

const Container = styled.div`
  background: #f5f5f5;
  position: relative;
  padding-bottom: 100px;
`

const Header = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  padding: 30px 0 20px;
  margin-bottom: 24px;

  position: sticky;
  top: 0;
  z-index: 5;

  @media only screen and (max-width: 768px) {
    padding: 15px 8px;
  }
`

const Title = styled.h1`
  font-family: Helvetica Neue;
  font-size: 28px;
  font-weight: 700;
  line-height: 34px;
  margin: 0 0 24px;

  @media only screen and (max-width: 768px) {
    font-size: 20px;
    margin-bottom: 18px;
  }
`

const HeaderRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 20px;
`

const TabList = styled.div`
  display: flex;
  flex-direction: row;
  gap: 18px;
  flex-wrap: wrap;

  @media only screen and (max-width: 768px) {
    gap: 5px;
  }
`

const Tab = styled.button`
  height: 42px;
  width: 172px;
  border-radius: 6px;
  padding: 10px;
  font-family: Helvetica Neue;
  font-size: 16px;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: center;
  color: ${({ isActive }) => (isActive ? '#fff' : '#000')};
  background-color: ${({ isActive }) => (isActive ? '#FF5E6D' : '#e5e5e5')};
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: none;

  @media only screen and (max-width: 768px) {
    width: fit-content;
    height: auto;
    padding: 6px 14px;
    font-size: 12px;
    line-height: 12px;
    border-radius: 3px;
    font-weight: 500;
    color: ${({ isActive }) => (isActive ? '#fff' : '#000')};
    background-color: ${({ isActive }) => (isActive ? '#FF5E6D' : '#F2F2F2')};
    border: 0.5px solid #d8d8d8;
  }
`

const HostButton = styled.button`
  height: 50px;
  width: 224px;
  border-radius: 80px;
  background-color: #ff5e6d;
  font-family: Helvetica Neue;
  font-size: 16px;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: left;
  color: #ffffff;
  padding: 0 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  cursor: pointer;
  border: none;
  @media only screen and (max-width: 768px) {
    display: none;
  }
`

const HostMobileButton = styled(HostButton)`
  display: none;
  height: 32px;
  width: 116px;
  border-radius: 80px;
  font-size: 12px;
  line-height: 15px;
  padding: 0;
  align-self: baseline;

  @media only screen and (max-width: 768px) {
    display: flex;
  }
`

const Center = styled.div`
  width: 100%;
  height: 100%;
  margin: auto;

  @media only screen and (min-width: 768px) {
    width: 768px;
  }

  @media only screen and (min-width: 992px) {
    width: 950px;
  }
  @media only screen and (min-width: 1400px) {
    width: 1270px;
  }

  @media only screen and (max-width: 768px) {
    box-sizing: border-box;
  }
`

const Content = styled.div`
  height: 100%;
  min-height: 60vh;
  @media only screen and (max-width: 768px) {
    min-height: 70vh;
    padding: 0 14px;
  }
`

const tabs = [
  {
    value: 'all',
    label: 'All'
  },
  {
    value: 'draft',
    label: 'Draft'
  },
  {
    value: 'reviewing',
    label: 'Reviewing'
  },
  {
    value: 'live',
    label: 'Live'
  },
  {
    value: 'end',
    label: 'Ended'
  }
]

const MyEvents = props => {
  const dispatch = useDispatch()
  const router = useRouter()
  const {
    feed: eventList,
    loading,
    error,
    end
  } = useSelector(state => state.myEventPlayTab)
  const { me } = useSelector(state => state.profile)
  const [toDelete, setToDelete] = useState()
  const [show, setShow] = useState(false)
  const [joinedUserEventStatuses, setJoinedUserEventStatuses] = useState(null)
  const [showLevelLimitationModal, setShowLevelLimitationModal] =
    useState(false)
  const [tab, setTab] = useState('all')

  const isMobile = useIsMobile()
  const isTablet = useMediaQuery('(max-width: 1024px)')

  const handleModalClose = () => {
    //rDeleteConfirmation.current.hide()
    setShow(false)
  }

  const handleDeleteToConfirm = data => {
    setShow(true)
    //rDeleteConfirmation.current.show()
    setToDelete(data)
  }

  const handleDelete = () => {
    if (!toDelete) return

    logEvent('draft_delete', {
      content_type: 'draft',
      content_id: toDelete.objectId
    })

    if (!toDelete.objectId) return

    deleteDraft(toDelete.objectId).then(() => {
      dispatch(fetchFeed('myEventPlayTab')({ status: FEED_RESET }))
      setShow(false)
    })
  }

  const { data, refetch, isFetching } = useQuery(
    ['PROFILE_MY_EVENTS', tab],
    async () => {
      const { userEvents } = await getMyUserEvents({
        statuses: statusesByTab[tab]
      })

      userEvents.forEach(event => {
        event.customStatus = event.status
        switch (event.status) {
          case 'active':
            if (moment(event.featuredAt?.iso).isAfter(moment())) {
              event.customStatus = 'scheduled'
              return
            }
            if (moment(event.expiresAt?.iso).isBefore(moment())) {
              event.customStatus = 'winnerSelection'
              return
            }
        }
      })

      return userEvents
    },
    {
      staleTime: 5000, // refetch after 5s
      cacheTime: 60000 // store in cache 60sec
    }
  )

  const renderGrid = events => (
    <Grid>
      {events?.map(event => {
        return (
          <CardWrapper key={event.objectId}>
            <MyEventCard
              {...event}
              {...me}
              objectId={event.objectId}
              refetch={refetch}
            />
          </CardWrapper>
        )
      })}
    </Grid>
  )

  const renderAll = () => {
    if (!data?.length) return

    const grouped = {
      draft: [],
      incomplete_submitted: [],
      scheduled_active: [],
      winnerSelection_closed: []
    }

    data.forEach(event => {
      switch (event.customStatus) {
        case 'draft':
          grouped.draft.push(event)
          break
        case 'incomplete':
        case 'submitted':
          grouped.incomplete_submitted.push(event)
          break
        case 'scheduled':
        case 'active':
          grouped.scheduled_active.push(event)
          break
        case 'winnerSelection':
        case 'closed':
          grouped.winnerSelection_closed.push(event)
          break
      }
    })

    return Object.keys(grouped).map(key => {
      const list = grouped[key]
      if (!list?.length) return null
      return (
        <Row key={key}>
          <RowTitle>{statusTitles[key]}</RowTitle>
          {renderGrid(list)}
        </Row>
      )
    })
  }

  return (
    <Container>
      <DeleteConfirmation
        show={show}
        title={'Delete your draft?'}
        onClose={handleModalClose}
        onDelete={handleDelete}
      >
        Are you sure you want to delete you draft?
      </DeleteConfirmation>
      <Header>
        {!isMobile && !isTablet && (
          <BackContainer>
            <Back onClick={() => router.back()} />
          </BackContainer>
        )}
        <Center>
          <HeaderRow>
            <Title>Host My Event</Title>
            <HostMobileButton onClick={() => router.push('/create/userEvent')}>
              Host
            </HostMobileButton>
          </HeaderRow>
          <HeaderRow>
            <TabList>
              {tabs.map(({ value, label }) => (
                <Tab
                  key={value}
                  onClick={() => setTab(value)}
                  isActive={value === tab}
                >
                  {label}
                </Tab>
              ))}
            </TabList>
            <HostButton onClick={() => router.push('/create/userEvent')}>
              Host MyEvent
            </HostButton>
          </HeaderRow>
        </Center>
      </Header>
      <Content>
        <Center>
          {tab === 'all' ? renderAll() : renderGrid(data)}
          {!isFetching && !data?.length && (
            <NoEvent>
              <img src={noitems} />
              <span>NO EVENT YET</span>
              <button onClick={() => router.push('/create/userEvent')}>
                Host Event
              </button>
            </NoEvent>
          )}
        </Center>
      </Content>
      {showLevelLimitationModal && (
        <UserEventLevelLimitationModal
          onClose={() => setShowLevelLimitationModal(false)}
        />
      )}
    </Container>
  )
}

export default MyEvents
